<template>
  <v-app class="app">
    <TopBar />
    <v-main class="content">
      <v-container fluid>
        <router-view v-slot="{ Component }">
          <transition>
            <component :is="Component" />
          </transition>
        </router-view>
      </v-container>
    </v-main>
    <FooterView/>
  </v-app>
  
</template>
<script>

import TopBar from "@/components/TopBar.vue";
import FooterView from "@/components/FooterView.vue";

export default {

  name: 'App',

  components: {
    TopBar,
    FooterView
},

}
</script>


<style scoped>

.app {
  font-family: "Nunito Sans Regular";
}

.content {
  background: rgb(222,240,237);
  background: linear-gradient(180deg, #def0e9 0%, rgba(190, 220, 215, 0) 100%);
  padding-bottom: 4em;
}

</style>